import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import { styled } from '@zenbusiness/zui/styles';

const PrintedBoxStyle = () => ({
  '@media print': {
    paddingTop: '12px',
    paddingLeft: '16px',
    paddingRight: '16px'
  }
});

const ButtonStyle = ({ theme }) => ({
  width: '100%',
  backgroundColor: 'transparent',
  border: `1px solid ${theme.palette.fixed.black}`
});

export const PrintedBox = styled(Box)(PrintedBoxStyle);
export const ButtonStyled = styled(Button)(ButtonStyle);
